package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2024_03_01_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes continue toward Cark but are interrupted by a balista bolt landing very near them. Perhaps a warning shot? The heroes see a group of large humanoids to the west: orcs, goblins, ettin, and something bigger than ettin. These creatures are clearly laying siege to Cark. Dirk signals Sorlon Dragstone and asks for reinforcements. A few hours later, Staff Sergeant Darbe Brownlee arrives with 30 men to liberate Cark. The heroes take on a support roll. Soon they enter combat with some orc warchiefs, goblins, ettin, a hill giant, and The Daveed that fled from the earlier battle with The Daveeds.")
    }
}
